<table width="100%" class="sb-table table dataTable no-footer nowrap" datatable [dtTrigger]="dtTrigger"
       [dtOptions]="dtOptions">
  <ng-container [ngTemplateOutlet]="tableHead"></ng-container>
  <ng-container [ngTemplateOutlet]="tableBody"></ng-container>
</table>
